export const penSvg = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2523757575'%3E%3Cpath d='M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'/%3E%3C/svg%3E")`;

export const activeStyles = {
  cursor: 'pointer',
  position: 'relative',
  pr: '2rem',
  zIndex: 1,
  backgroundColor: 'transparent',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: 'action.hover',
  },
  '&::after': {
    top: '50%',
    right: '0.5rem',
    content: '""',
    zIndex: 0,
    width: '1rem',
    height: '1rem',
    position: 'absolute',
    transform: 'translateY(-50%)',
    opacity: '0',
    transition: 'opacity 0.5s ease',
    backgroundImage: penSvg,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    pointerEvents: 'none',
  },
  '&:hover::after': {
    opacity: '0.5',
  },
};

export const disabledStyles = {
  cursor: 'not-allowed',
};
